const CHECK_INTERVAL_MS = 60000;
const CURRENT_VERSION = process.env.REACT_APP_VERSION;

const VERSION_RELOAD_FLAG_KEY = "dreamclouds_version_reloaded";

// Force the reload silently, but only once per tab session, so a
// version mismatch that persists after reload (e.g. a mid-deploy
// race) can't put the user in a reload loop.
const forceReloadOnce = () => {
  if (sessionStorage.getItem(VERSION_RELOAD_FLAG_KEY)) return;
  sessionStorage.setItem(VERSION_RELOAD_FLAG_KEY, "1");
  window.location.reload();
};

const checkVersion = async () => {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-store",
    });
    if (!response.ok) return;
    const latest = await response.json();
    if (latest?.version && latest.version !== CURRENT_VERSION) {
      forceReloadOnce();
    }
  } catch {
    // Network hiccup - just retry on the next interval.
  }
};

// Skip polling when there's no baked-in version to compare against
// (e.g. local dev), otherwise every check would look like a new deploy.
export const initVersionPolling = () => {
  if (!CURRENT_VERSION) return;

  setInterval(checkVersion, CHECK_INTERVAL_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") checkVersion();
  });
};

const RELOAD_FLAG_KEY = "dreamclouds_chunk_reload_at";
const RELOAD_COOLDOWN_MS = 30000;

const isChunkLoadError = (message) =>
  typeof message === "string" &&
  (message.includes("Loading chunk") ||
    message.includes("Loading CSS chunk") ||
    message.includes("Failed to fetch dynamically imported module"));

// A stale build reference after a deploy is unrecoverable, so reload
// immediately. The cooldown guards against a reload loop if the new
// shell still points at a missing chunk.
const handleChunkLoadError = () => {
  const lastReload = Number(sessionStorage.getItem(RELOAD_FLAG_KEY) || 0);
  if (Date.now() - lastReload < RELOAD_COOLDOWN_MS) return;
  sessionStorage.setItem(RELOAD_FLAG_KEY, String(Date.now()));
  window.location.reload();
};

export const initChunkErrorHandling = () => {
  window.addEventListener("error", (event) => {
    if (isChunkLoadError(event?.message)) handleChunkLoadError();
  });
  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkLoadError(event?.reason?.message)) handleChunkLoadError();
  });
};
